import React from 'react';
import classNames from 'classnames';
import { StyledChipTabs } from './index.style';

// Giống ChipTabs nhưng bật tắt được nhiều chip nên `values` là mảng.
const ChipToggles = ({ width, options, values, onChange }) => {
  const toggle = (optionValue) =>
    onChange(
      values.includes(optionValue)
        ? values.filter((item) => item !== optionValue)
        : [...values, optionValue],
    );

  return (
    <StyledChipTabs $width={width}>
      {options.map(({ value: optionValue, icon: Icon, disabled }) => (
        <button
          key={optionValue}
          type="button"
          disabled={disabled}
          aria-pressed={values.includes(optionValue)}
          className={classNames('chip-tab', {
            'chip-tab-active': values.includes(optionValue),
          })}
          onClick={() => toggle(optionValue)}
        >
          <Icon />
        </button>
      ))}
    </StyledChipTabs>
  );
};

export default ChipToggles;
